<template>
    <v-pagination
        circle
        prev-icon="icon-left"
        next-icon="icon-right"
        :length="item.last_page"
        v-model="item.current_page"
        :total-visible="7"
        @input="inputHandler"
    />
</template>

<script>
    export default {
        props: {
            item: {
                type: [Object, Array],
                required: true,
            },
            requestFunction: {
                type: Function,
                required: true,
            },
            options: {
                type: Object,
                required: false,
            }
        },

        methods: {
            inputHandler(page) {
                this.$store.dispatch('PAGINATE', { page, requestFunction: this.requestFunction, options: this.options} )
            }
        }
    }
</script>

<style lang="sass" scoped>
.v-pagination__navigation
    box-shadow: none
    background: $color--white
</style>